import styles from "@entities/Onboarding/ui/styles.module.scss";
import { errorMessages } from "@features/Onboarding/lib/constants";
import { useSignInValidation } from "@features/Onboarding/lib/hooks/useSignInValidation";
import { AuthStep } from "@pages/Onboarding/Onboarding";
import { Button, Flex, Form, Input } from "antd";
import { ChevronLeft } from "lucide-react";
import React, { useState } from "react";

interface ForgotPasswordFormValues {
  email: string;
}

interface ForgotPasswordFormProps {
  navigateTo: (step: AuthStep) => void;
}

export const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({
  navigateTo,
}) => {
  const { handlePasswordReset, isResetting } = useSignInValidation();
  const [errors, setErrors] = useState<Partial<ForgotPasswordFormValues>>({});

  const onFinish = async (values: ForgotPasswordFormValues) => {
    try {
      await handlePasswordReset(values.email);
      navigateTo("CHECK_EMAIL");
    } catch (error) {
      setErrors(error as Partial<ForgotPasswordFormValues>);
    }
  };

  return (
    <div className={styles.fadeIn}>
      <h2 className={styles.subTitle}>Reset your password</h2>
      <p className={styles.description}>
        Enter the email address associated with your account, and we'll send you
        a link to reset your password.
      </p>
      <Form
        layout="vertical"
        onFinish={onFinish}
        size="large"
        requiredMark={false}
        style={{ marginBottom: 20 }}
      >
        <Form.Item
          label="Email"
          name="email"
          className={styles.formItem}
          rules={[
            { required: true, message: errorMessages.email },
            { pattern: /\S+@\S+\.\S+/, message: errorMessages.email },
          ]}
          validateStatus={errors.email ? "error" : ""}
          help={errors.email}
        >
          <Input placeholder="name@company.com" disabled={isResetting} />
        </Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          block
          size="large"
          loading={isResetting}
        >
          Continue
        </Button>
      </Form>
      <a onClick={() => navigateTo("LOGIN")} className={styles.forgotLink}>
        <Flex gap={5} align="center">
          <ChevronLeft size={16} />
          Return to sign in
        </Flex>
      </a>
    </div>
  );
};
